<template>
  <PageContent class="flex-1">
    <query-wrapper :status="status">
      <template #error>
        <div class="mt-4">
          <pane class="bg-red-50 text-red-600">Failed to fetch projects.</pane>
        </div>
      </template>

      <template v-if="projects.length === 0">
        <Empty heading="Create your first Craft Cloud project" icon="cloud">
          Craft hosting without complexity. Purpose-built for Craft, by Craft.

          <template #cta>
            <btn kind="primary" :to="getPrefixedTo('/cloud/projects/new')">
              New project
            </btn>

            <div class="mt-2 text-sm">
              <a
                href="https://craftcms.com/cloud"
                title="Learn more about Craft Cloud"
                >Learn more</a
              >
            </div>
          </template>
        </Empty>
      </template>
      <template v-else>
        <div class="flex items-center justify-between">
          <page-header>
            <h1>Projects</h1>
            <btn
              data-testid="btn-new-project"
              :disabled="!can(Ability.ManageProjects)"
              kind="primary"
              :to="getPrefixedTo('/cloud/projects/new')"
            >
              New project
            </btn>
          </page-header>
        </div>

        <projects-table :projects="projects" />

        <div class="flex gap-4 mt-4 items-center justify-between">
          <PartShowing :from="meta.from" :to="meta.to" :total="meta.total" />

          <div class="flex items-center justify-between gap-2">
            <Spinner v-if="isFetching" />

            <PaginationLinks
              @click:previous="previousPage"
              @click:next="nextPage"
              :can-previous="meta.current_page > 1"
              :can-next="meta.current_page < meta.last_page"
            />
          </div>
        </div>
      </template>
    </query-wrapper>
  </PageContent>
</template>

<script setup lang="ts">
  import Btn from '@/common/ui/components/Btn.vue';
  import {getPrefixedTo} from '@console/helpers/router';
  import ProjectsTable from '@console/components/cloud/ProjectsTable.vue';
  import {useGetProjectList} from '@console/queries/projects';
  import QueryWrapper from '@console/components/QueryWrapper.vue';
  import Pane from '@/common/ui/components/Pane.vue';
  import PageContent from '@console/components/PageContent.vue';
  import {Ability, useAbility} from '@console/composables/useAbility';
  import Empty from '@console/components/Empty.vue';
  import PageHeader from '@console/components/app/PageHeader.vue';
  import Spinner from '@/common/ui/components/Spinner.vue';
  import PartShowing from '@console/components/tables/PartShowing.vue';
  import PaginationLinks from '@console/components/PaginationLinks.vue';

  const {projects, meta, nextPage, previousPage, isFetching, status} =
    useGetProjectList({sort: '-updated_at'});
  const {can} = useAbility();
</script>
